import React, { useState } from 'react'
import styled from 'styled-components'
import Icon from '../../../components/Icon'
import styles from '../../../constants/styles'
import { _ } from '../../../utils/localization'
import PublicChat from '../../publicchat/PublicChat'

const S = {
    Wrapper: styled.div<{isShowPublicChat: boolean}>`
        background: white;
        width: ${styles.sidebarWidth}px;
        height: 100%;
        position: fixed;
        top: 0;
        display: flex;
        flex-direction: column;
        padding-top: ${styles.topNavHeight}px;
        padding-bottom: 10px;
        right: ${({ isShowPublicChat }) => (isShowPublicChat ? 0 : -(styles.sidebarWidth))}px;
        transition: 0.75s;
        @media (max-width: 1366px) {
            width: ${styles.smallerSidebarWidth}px;
            right: ${({ isShowPublicChat }) => (isShowPublicChat ? 0 : -(styles.smallerSidebarWidth))}px;
        }
    `,
    Header: styled.div`
        padding: 12px 10px;
        font-size: 20px;
        font-weight: 500;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    `,
    Tab: styled.div`
        position: absolute;
        left: 0;
        top: 50%;
        width: 36px;
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 8px 0 0 8px;
        transform: translate(-100%, -50%);
        box-shadow: -2px 1px 2px rgba(0, 0, 0, 0.1);
    `
}

const Sidebar = (
    { chatId }: {chatId: number}
) => {
    const [isShowPublicChat, setShowPublicChat] = useState(false)

    return (
        <S.Wrapper isShowPublicChat={isShowPublicChat}>
            <S.Tab onClick={() => setShowPublicChat(!isShowPublicChat)}>
                <Icon icon="forum" />
            </S.Tab>
            <S.Header>
                {_('presentation.public_chat.title')}
            </S.Header>
            {isShowPublicChat && <PublicChat chatId={chatId} />}
        </S.Wrapper>
    )
}

export default Sidebar
